export default "__VITE_ASSET__CNfZ0N4J__"